import React from "react";
import "./PrivacyPolicy.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import SocialMediaPanel from "../common/social-media/SocialMediaPanel";

export default function TermCondition() {
  return (
    <>
      
       
      <main className="privacy-policy-page">
        {/* Header */}
        <header className="privacy-policy-header">
          <h1 className="privacy-policy-title">Terms & Conditions – PYQPEDIA</h1>
          <span><strong>Effective Date:</strong> 25th September 2025.</span>
          <p className="privacy-policy-subtitle">
            Welcome to PYQPEDIA. By accessing or using our website{" "}
            <a
              href="https://www.pyqpedia.com/"
              className="no-capitalize pyq-link"
              target="_blank"
              rel="noreferrer"
            >
              www.pyqpedia.com
            </a>, you agree to comply with and be bound by the following Terms & Conditions.
          </p>
        </header>

        {/* Content */}
        <section className="privacy-policy-content">
          {/* 1. Services Offered */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">1. Services Offered</h2>
            <ul className="privacy-policy-list">
              <li>PYQPEDIA provides <strong>online mock tests and educational resources</strong> for competitive exams.</li>
              <li>All services are digital and accessible online.</li>
            </ul>
          </article>

          {/* 2. User Responsibilities */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">2. User Responsibilities</h2>
            <ul className="privacy-policy-list">
              <li>Users must provide accurate details during registration and payment.</li>
              <li>Sharing login credentials, reselling content, or misuse of services is strictly prohibited.</li>
            </ul>
          </article>

          {/* 3. Payments */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">3. Payments</h2>
            <ul className="privacy-policy-list">
              <li>All payments are accepted in INR via authorized payment gateways (Debit/Credit Cards, Net Banking, UPI, Wallets, etc.).</li>
              <li>Users are responsible for any applicable transaction fees.</li>
            </ul>
          </article>

          {/* 4. Intellectual Property */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">4. Intellectual Property</h2>
            <ul className="privacy-policy-list">
              <li>All content, study materials, tests, and designs belong to <strong>PYQPEDIA</strong>.</li>
              <li>Unauthorized reproduction, distribution, or commercial use is prohibited.</li>
            </ul>
          </article>

          {/* 5. Limitation of Liability */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">5. Limitation of Liability</h2>
            <ul className="privacy-policy-list">
              <li>PYQPEDIA is not responsible for connectivity issues, device failures, or exam outcomes.</li>
              <li>Liability, if any, is limited to the fee paid by the user.</li>
            </ul>
          </article>

          {/* 6. Governing Law */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">6. Governing Law</h2>
            <ul className="privacy-policy-list">
              <li>These Terms shall be governed by Indian law.</li>
              <li>Any disputes shall be subject to courts in <strong>Delhi, India</strong>.</li>
            </ul>
          </article>
          <p>
              <strong>This website is operated by : </strong>
              BACHCHA JHA
            </p>
            <p>
              <strong>Trade Name : </strong>
              Pyq Pedia
            </p>
        </section>

        {/* Footer */}
        <footer className="privacy-policy-footer">
          <p>Issued by <strong>PYQPEDIA Team</strong></p>
        </footer>
      </main>

      
    </>
  );
}
